import translationsPtBr from './translations.pt-br';

export default {
  en: {},
  'pt-BR': translationsPtBr
};
